import Vue from 'vue'
import Vuex from 'vuex'
import menu from './modules/menu'
import bank from './modules/bank'
import banner from './modules/banner'
import email from './modules/email'
import version from './modules/version'
import drivers from './modules/drivers'
import shareCar from './modules/shareCar'
import lowsource from './modules/lowsource'
import enquiry from './modules/enquiry'
import heightWaybill from './modules/heightWaybill'
import userlist from './modules/userlist'
import share from './modules/share'
import message from './modules/message'
import financialfirm from './modules/financialfirm'
import menuInfo from './modules/menuInfo'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    menu,
    bank,
    banner,
    email,
    version,
    drivers,
    shareCar,
    lowsource,
    enquiry,
    heightWaybill,
    userlist,
    share,
    financialfirm,
    message,
    menuInfo
  }
})
